import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import Issues from "./Issues";
const IssuesTabContent = () => {
    return (React.createElement(ErrorBoundary, { key: "issues" },
        React.createElement(Issues, null)));
};
export default IssuesTabContent;
//# sourceMappingURL=IssuesTabContent.js.map